module.exports = __webpack_public_path__ + "static/media/bannerTablet@2x.58a4e2e0.jpg";